/**
 * Component Registry for Bridges Apartment Homes
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-vantage/registry';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  SpecialOfferBanner,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
